import { makeStyles, tokens } from '@fluentui/react-components';

export const useFormLayoutStyles = makeStyles({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  twoCol: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: tokens.spacingHorizontalM,
    minWidth: 0,
  },
  twoColStacked: {
    gridTemplateColumns: '1fr',
  },
  col: {
    minWidth: 0,
  },
  toggleField: {
    alignItems: 'center',
    gridTemplateColumns: 'auto auto',
    justifyContent: 'start',
    width: 'fit-content',
    columnGap: tokens.spacingHorizontalM,
  },
});
